"use client";

import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { useEffect } from "react";

interface DraggableContextMenuItemProps {
  id: string;
  imageUrl: string;
  name: string;
  onDragStart?: () => void;
  onClick?: () => void;
}

export function DraggableContextMenuItem({
  id,
  imageUrl,
  name,
  onDragStart,
  onClick,
}: DraggableContextMenuItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
  } = useDraggable({
    id,
    data: { imageUrl, name },
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : 1,
  };

  // Notify parent when drag starts
  useEffect(() => {
    if (isDragging && onDragStart) {
      onDragStart();
    }
  }, [isDragging, onDragStart]);

  return (
    <button
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      onClick={(e) => {
        // Only trigger onClick if not dragging
        if (!isDragging && onClick) {
          onClick();
        }
      }}
      className="relative aspect-square rounded overflow-hidden bg-card border border-border hover:border-primary hover:shadow-md transition-all cursor-grab active:cursor-grabbing group"
      title={name}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover"
        />
      )}
      {/* Hover overlay */}
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
    </button>
  );
}
